import React, { FC } from "react";

import { useBoolean } from "~/hooks";

import { EmployeeSurveyQuestionSummaryType } from "~/domains";

import { ModalWrapper, Icon, ButtonWithIcon } from "~/ui";

type PropsType = {
  summary: EmployeeSurveyQuestionSummaryType;
  className?: string;
};

export const EmployeeSurveysSummariesAnswers: FC<PropsType> = ({
  className = "",
  summary,
}) => {
  const { isChecked: open, setTrue, setFalse } = useBoolean(false);

  const employeeNames: string[] = summary.employeeNames;
  return (
    <div className={`rounded-lg border border-secondary-200 p-4 ${className}`}>
      <div className="text-secondary-800 font-medium mb-3 leading-relaxed whitespace-pre-wrap break-words">
        {summary.answer}
      </div>
      <div className="relative flex items-center justify-between">
        <button
          onClick={setTrue}
          disabled={summary.count < 1}
          type="button"
          className="inline-flex items-center text-primary-600 text-sm font-medium hover:text-primary-800 transition-colors"
        >
          <Icon
            icon="ioPerson"
            size="0.9rem"
            color="text-primary-600"
            className="mr-1"
          />
          {summary.count}件の回答
        </button>
        {open && employeeNames.length > 0 && (
          <>
            <ModalWrapper isWhite onClose={setFalse} />
            <div
              className="absolute left-0 z-modal min-w-max max-w-sm shadow-xl
                          bg-white border border-secondary-300 rounded-lg top-full mt-2 p-3"
            >
              <div className="flex items-center justify-between mb-3 pb-2 border-b border-secondary-200">
                <h5 className="font-medium text-secondary-900 text-sm flex items-center">
                  <Icon
                    icon="ioPerson"
                    size="0.9rem"
                    color="text-primary-600"
                    className="mr-2"
                  />
                  回答者一覧
                </h5>
                <ButtonWithIcon
                  onClick={setFalse}
                  withHoverEffect={true}
                  srOnlyText="回答者一覧を閉じる"
                  icon={{
                    icon: "ioCloseOutline",
                    size: "1rem",
                    color: "text-gray-500",
                  }}
                />
              </div>
              <div className="space-y-1 max-h-48 overflow-y-auto mb-2">
                {employeeNames.map((employee, index) => (
                  <div
                    key={index}
                    className="px-2 py-1 text-secondary-700 text-sm rounded"
                  >
                    {employee}
                  </div>
                ))}
              </div>
              <div className="pt-2 border-t border-secondary-200 text-center">
                <div className="text-xs text-secondary-600">
                  全{employeeNames.length}名
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
